module.exports = __webpack_public_path__ + "static/img/comfirBtnGavi.c7b68d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img/comfirBtnGavi.png
// module id = aoIE
// module chunks = 1